export { default } from './Tooltip';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Tooltip/index.js
// module id = 131
// module chunks = 2